// removed by extract-text-webpack-plugin
module.exports = {"header":"_3Vdub8gB7fZPctXbemkaZx","close":"_1X1oex95erTZpTsgJ2xoby"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/Header.scss
// module id = 2895
// module chunks = 0